const InputPrice = ({label,validated,classWrap="ms-item",clasInput="fm-form-input",...rest}) =>{

	return (
		<div className={classWrap}>
		{
			label !== "" ?
			<label htmlFor={rest.name}>{label}</label>
			:null
		}
			
			{
				validated==="yes" ?
					rest.value.length === 0 || rest.value === "0" ?
					<input type="number" className={clasInput+" disabled"} {...rest} id={rest.name} />
					:
					<input type="number" className={clasInput} {...rest} id={rest.name} />
				:
				<input type="number" className={clasInput} {...rest} id={rest.name} />
			}
			
		</div>
	)
}

export default InputPrice